var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 916.9,
    height: 271.8,
    viewBox: "0 0 916.9 271.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.501,
    y1: -0.003,
    x2: 0.501,
    y2: 0.992,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#267caf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4a92b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#79bcba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88cebc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.638,
    y1: 0.14,
    x2: 0.338,
    y2: 0.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f5907a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fbb777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdc874"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.866,
    y1: 0.172,
    x2: 0.048,
    y2: 1.03,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb413d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d94452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#af487a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#954b92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#894a9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.106,
    y1: 0.073,
    x2: 0.888,
    y2: 0.85,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54c0ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde79a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232721",
    "data-name": "Group 232721",
    transform: "translate(-138.8 -464.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236100",
    "data-name": "Path 236100",
    d: "M1049.7,703.8a26.012,26.012,0,0,1-26,26H170.9a26.033,26.033,0,0,1-26.1-26V496.3a26.119,26.119,0,0,1,26.1-26.1h852.6a26.1,26.1,0,0,1,26.1,26h0V703.7h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236101",
    "data-name": "Path 236101",
    d: "M1023.6,735.8H170.9a32.136,32.136,0,0,1-32.1-32.1V496.2a32.136,32.136,0,0,1,32.1-32.1h852.6a32.136,32.136,0,0,1,32.1,32.1V703.7a32.136,32.136,0,0,1-32.1,32.1h0Z",
    fill: "#a6a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236102",
    "data-name": "Path 236102",
    d: "M1049.7,703.8a26.012,26.012,0,0,1-26,26H170.9a26.033,26.033,0,0,1-26.1-26V496.3a26.119,26.119,0,0,1,26.1-26.1h852.6a26.1,26.1,0,0,1,26.1,26h0V703.7h0Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236103",
    "data-name": "Path 236103",
    d: "M1023.6,464.2H566.9L745.8,735.9h277.8a32.136,32.136,0,0,0,32.1-32.1V496.3a32.136,32.136,0,0,0-32.1-32.1Z",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_232720",
    "data-name": "Group 232720"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236104",
    "data-name": "Path 236104",
    d: "M462.8,546.3c0,5.3-1.3,10-4.6,13.3a20.648,20.648,0,1,1-14.6-35.2c6,0,5.3.7,8,2a15.211,15.211,0,0,1,6,4.6l-3.3,3.3c-2.7-3.3-6-4.6-10.6-4.6s-8,1.3-10.6,4.6c-3.3,2.7-4.6,6.6-4.6,11.3s1.3,8.6,4.6,11.3,6.6,4.6,10.6,4.6a15.547,15.547,0,0,0,11.3-4.6,10.9,10.9,0,0,0,3.3-8H443.7v-5.3H463v2.7h-.2Zm30.6-16.6H475.5v12.6h16.6v4.6H475.5v12.6h17.9v5.3H470.2V525h23.2v4.7Zm21.9,35.2H510V529.7H498.7v-4.6h27.9v4.6H515.3v35.2Zm30.5,0V525.1h5.3v39.8Zm27.9,0h-5.3V529.7H557.1v-4.6h27.2v4.6H573v35.2h.7Zm63.1-5.3a20.763,20.763,0,1,1,6-14.6A19.454,19.454,0,0,1,636.8,559.6Zm-25.2-3.3a15.424,15.424,0,0,0,10.6,4.6c4,0,8-1.3,10.6-4.6a15.817,15.817,0,0,0,4.6-11.3c0-4.7-1.3-8.6-4.6-11.3a15.424,15.424,0,0,0-10.6-4.6c-4,0-8,1.3-10.6,4.6A15.817,15.817,0,0,0,607,545C607,549.7,608.3,553.6,611.6,556.3Zm38.5,8.6V525.1h6l19.3,31.2V525.1h5.3v39.8h-5.3l-20.6-32.5v32.5h-4.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236105",
    "data-name": "Path 236105",
    d: "M600.3,614.7c-15.9,0-28.6,12-28.6,28.6s12.6,28.6,28.6,28.6,28.6-12,28.6-28.6S616.3,614.7,600.3,614.7Zm0,45.1c-8.6,0-15.9-7.3-15.9-17.3s7.3-17.3,15.9-17.3,15.9,6.6,15.9,17.3S608.9,659.8,600.3,659.8Zm-61.8-45.1c-15.9,0-28.6,12-28.6,28.6s12.6,28.6,28.6,28.6,28.6-12,28.6-28.6S554.5,614.7,538.5,614.7Zm0,45.1c-8.6,0-15.9-7.3-15.9-17.3s7.3-17.3,15.9-17.3,15.9,6.6,15.9,17.3S547.1,659.8,538.5,659.8Zm-73.7-36.5v12h28.6c-.7,6.6-3.3,12-6.6,15.3-4,4-10.6,8.6-21.9,8.6-17.9,0-31.2-13.9-31.2-31.9s13.9-31.9,31.2-31.9,16.6,4,21.9,8.6l8.6-8.6c-7.3-6.6-16.6-12-29.9-12-23.9,0-44.5,19.9-44.5,43.8S441.6,671,465.5,671s22.6-4,30.5-12.6c8-8,10.6-19.3,10.6-27.9s0-5.3-.7-7.3H464.7Zm301.5,9.3c-2.7-6.6-9.3-17.9-23.9-17.9s-26.6,11.3-26.6,28.6,12,28.6,27.9,28.6,20.6-8,23.2-12.6l-9.3-6.6c-3.3,4.6-7.3,8-13.9,8s-10.6-2.7-13.9-8.6l37.9-15.9-1.3-3.3h0Zm-38.5,9.3c0-10.6,8.6-16.6,14.6-16.6s9.3,2.7,10.6,6l-25.2,10.6h0Zm-31.2,27.2h12.6v-83H696.6Zm-20-48.4a21.836,21.836,0,0,0-15.3-6.6c-13.9,0-27.2,12.6-27.2,28.6a27.449,27.449,0,0,0,27.2,27.9c14.6,0,12-3.3,14.6-6.6h.7v4c0,10.6-6,16.6-15.3,16.6s-12.6-5.3-13.9-10l-10.6,4.6c3.3,7.3,11.3,16.6,25.2,16.6s26.6-8.6,26.6-29.2V616.1h-12v4.6h0ZM662,659.8c-8.6,0-15.9-7.3-15.9-17.3s7.3-17.3,15.9-17.3,15.3,7.3,15.3,17.3S670.7,659.8,662,659.8Zm162.1-73.7H794.2v83h12.6V637.9h17.3c13.9,0,27.2-10,27.2-25.9s-13.3-25.9-27.2-25.9Zm.6,39.9H806.8V597.4h17.9a14.589,14.589,0,0,1,14.6,13.9c-.7,7.3-6,14.6-14.6,14.6h0Zm76.4-12c-9.3,0-18.6,4-21.9,12.6l11.3,4.6c2.7-4.6,6.6-6,11.3-6,6.6,0,12.6,4,13.3,10.6v.7a26.69,26.69,0,0,0-12.6-3.3c-12,0-23.9,6.6-23.9,18.6s10,18.6,20.6,18.6,12.6-4,15.9-8h.7V669h12V637.1c-1.3-14.6-12.6-23.2-26.6-23.2h0Zm-1.3,45.8c-4,0-10-2-10-7.3s7.3-8.6,13.3-8.6,8,1.3,11.3,2.7c-1.3,8-8,13.3-14.6,13.3ZM969.5,616l-13.9,35.9h-.7L940.3,616H927l21.9,50.5-12.6,27.9h12.6L982.8,616H969.5ZM857.9,669.1h12.6v-83H857.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_232719",
    "data-name": "Group 232719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236106",
    "data-name": "Path 236106",
    d: "M237.5,519.3c-2,2-2.7,5.3-2.7,9.3V675.4c0,4,1.3,7.3,3.3,9.3l.7.7,82.3-82.3v-1.3l-83.7-82.3Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236107",
    "data-name": "Path 236107",
    d: "M347.7,630.9l-27.2-27.2v-2l27.2-27.2.7.7,32.5,18.6c9.3,5.3,9.3,13.9,0,19.3L347.7,631Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236108",
    "data-name": "Path 236108",
    d: "M348.4,630.2l-27.9-27.9-83,83c3.3,3.3,8,3.3,13.9.7l97-55.8",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236109",
    "data-name": "Path 236109",
    d: "M348.4,574.4l-97-55.1c-6-3.3-10.6-2.7-13.9.7l83,82.3,27.9-27.9Z",
    fill: "url(#linear-gradient-4)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.9bfbb424a01c3052a80aaf1b45114ded.svg";
export { ForwardRef as ReactComponent };